<template>
  <div id="tagsAccordions" :class="isPhoneMode ? 'tags-accordions-phone' : 'tags-accordions-desktop'">
    <div class="container-label">
      <Accordion title="HÉBERGEMENTS" :tags="hebergements" />
      <Accordion title="DESTINATIONS" :tags="destinationsTags" />
      <Accordion title="WEEK-ENDS" :tags="weekendsTags" />
      <Accordion title="EXPÉRIENCES" :tags="collectionsTags" />
    </div>
  </div>
</template>

<script>
import Accordion from './Accordion.vue';
import fetcher from '../../packs/shared/api.js';

export default {
  name: 'tagsAccordions',
  props: ['destinations', 'weekends', 'collections', 'accommodations', 'phone-mode'],
  components: {
    Accordion
  },
  computed: {
    isPhoneMode() {
      if (this.phoneMode !== undefined) return this.phoneMode;
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent);
    },
    destinationsTags() {
      const pageTags = this.getPageDestinationsTags();
      const source = this.destinations || this.fetchedDestinations;
      const tags = []
      
      const allowedRegions = [
        "Occitanie",
        "Nouvelle-Aquitaine",
        "Pays de la Loire",
        "Corse",
        "Provence-Alpes-Côte d’Azur",
        "Bourgogne-Franche-Comté",
        "Normandie",
        "Ile-de-France",
        "Bretagne",
        "Centre-Val de Loire",
        "Auvergne-Rhône-Alpes",
        "Grand Est",
        "Hauts-de-France",
        "océan indien",
        "caraïbes",
        "afrique"
      ]

      if (source) {
        source.forEach((destination) => {
          // if (allowedRegions.includes(destination.name)) {
          //   tags.push({ name: destination.name, link: `/destination/${destination.slug}` })
          // }
          destination.regions?.forEach((region) => {
            if (region.name && region.slug && destination.name == "France") {
              tags.push({ name: region.name, link: `/destination/${region.slug}` })
            }
          })
        })
      }

      return this.mergeTags(tags, pageTags)
    },

    weekendsTags() {
      const source = this.weekends || this.fetchedWeekends;
      return source ? source
        .filter(weekend => weekend.category !== null)
        .map(weekend => ({ name: `Week-end ${weekend.category}`, link: `/weekends/week-end-${weekend.slug}` })) : []
    },

    collectionsTags() {
      const source = this.collections || this.fetchedCollections;
      if (!source) return []

      const specialCollections = [
        "chambres d'hôtes",
        "Evénement éco-responsable",
        "Voyages d'affaires",
        "Location",
        "Voyage de noces"
      ]

      let normalCollections = []
      let specialCollectionsList = []

      source.forEach(collection => {
        const formattedCollection = { name: collection.collection, link: `/collections/${collection.slug}` }
        if (specialCollections.includes(collection.collection)) {
          specialCollectionsList.push(formattedCollection)
        } else {
          normalCollections.push(formattedCollection)
        }
      })

      return [...normalCollections, ...specialCollectionsList]
    }
  },

  data() {
    return {
      hebergements: [],
      pageHebergements: [],
      fetchedDestinations: null,
      fetchedWeekends: null,
      fetchedCollections: null
    }
  },
  methods: {
    getPageDestinationsTags() {
      const context = window.__HortenseTagsAccordions || {};
      return Array.isArray(context.destinations) ? context.destinations : [];
    },

    getPageHebergementsTags() {
      const context = window.__HortenseTagsAccordions || {};
      return Array.isArray(context.hebergements) ? context.hebergements : [];
    },

    mergeTags(defaultTags, pageTags) {
      if (!Array.isArray(pageTags) || pageTags.length === 0) return defaultTags;

      const merged = [...defaultTags, ...pageTags];
      const uniqueByLink = new Map();

      merged.forEach((tag) => {
        if (!tag?.link) return;
        if (!uniqueByLink.has(tag.link)) uniqueByLink.set(tag.link, tag);
      });

      return Array.from(uniqueByLink.values());
    },

    mergeHebergements(defaultTags, pageTags) {
      return this.mergeTags(defaultTags, pageTags);
    },

    fetchHebergements() {
      return [
        { name: "Hôtel de charme", link: "/hotel-de-charme" },
        { name: "Chambres d'hôtes de charme", link: "/chambres-dhotes-de-charme" },
        { name: "Villas de charme", link: "/villa-de-charme" },
        { name: "Maisons de charme", link: "/maisons-de-charme" },
        { name: "Logement insolite de luxe", link: "/logement-insolite-de-luxe" },
        { name: "Chalets", link: "/chalet" },
        { name: "Ecolodge", link: "/ecolodge" },
        { name: "Hôtel de luxe", link: "/hotel-luxe" },
        { name: "Hôtel 5 étoiles", link: "/hotel-5-etoiles" },
        { name: "Hôtel 4 étoiles", link: "/hotel-4-etoiles" },
        { name: "Hôtel 3 étoiles", link: "/hotel-3-etoiles" },
        { name: "Hôtel bord de mer", link: "/hotel-bord-de-mer" },
        { name: "Hôtel piscine", link: "/hotel-piscine" },
        { name: "Hôtel romantique", link: "/hotel-romantique" },
        { name: "Hôtel gastronomique", link: "/hotel-gastronomique" },
        { name: "Hôtel châteaux", link: "/hotel-chateaux" },
        { name: "Villa de luxe piscine", link: "/villa-de-luxe-piscine" },
        { name: "Location jacuzzi", link: "/location-jacuzzi" },
        { name: "Location piscine", link: "/location-piscine" },
        { name: "Chambre d'hôtes piscine", link: "/chambre-dhotes-piscine" },
        { name: "Maisons d'hôtes piscine", link: "/maisons-dhotes-piscine" }
      ];

    },
  },
  async mounted() {
    this.pageHebergements = this.getPageHebergementsTags()
    this.hebergements = this.mergeHebergements(this.fetchHebergements(), this.pageHebergements)
    if (!this.destinations) {
      try {
        const res = await fetcher.get("/destination", {
          params: { countries: ['FRANCE', 'OCÉAN INDIEN', 'CARAÏBES', 'AFRIQUE'] }
        });
        this.fetchedDestinations = res.data;
      } catch (e) {
        console.error('Error fetching destinations in TagsAccordions:', e);
      }
    }
    if (!this.weekends) {
      try {
        const res = await fetcher.get("/weekends/");
        this.fetchedWeekends = res.data;
      } catch (e) {
        console.error('Error fetching weekends in TagsAccordions:', e);
      }
    }
    if (!this.collections) {
      try {
        const res = await fetcher.get("/collections/");
        this.fetchedCollections = res.data;
      } catch (e) {
        console.error('Error fetching collections in TagsAccordions:', e);
      }
    }
  }
}
</script>


<style lang="scss" scoped>
#tagsAccordions {
  padding: 50px 0px;
}

.tags-accordions-phone {
  padding: 70px 20px 0 20px !important;
  .container-label {
    width: 100% !important;
  }
}

.tags-accordions-desktop {
  .container-label {
    width: 100% !important;
    padding-left: 50px;
    padding-right: 50px;
  }
}
</style>
